export const listing = {
  companyHash: true,
  id: true,
  condition: true,
  mainImage: true,
  /**
   * images to extract multiple images
   */
  images: true,
  type: true,
  registration: {
    year: true,
    date: true,
    number: true,
  },
  cap: {
    id: true,
  },
  status: true,
  identifiers: {
    stockId: true,
  },
  externalUrl: true,
  attentionGrabber: true,
  manufacturer: true,
  model: true,
  variant: true,
  odometer: {
    value: true,
    unit: true,
  },
  engine: {
    description: true,
  },
  fuel: {
    type: true,
  },
  transmission: {
    type: true,
  },
  finances: {
    payment: true,
    deposit: true,
    productName: true,
    term: true,
    productType: true,
    annualMileage: true,
    percentageDeposit: true,
  },
  colour: {
    exterior: true,
    exteriorCode: true,
  },
  bodyStyle: true,
  price: {
    current: true,
    currencyCode: true,
    previous: true,
    vatIncluded: true,
  },
  location: {
    name: true,
    hash: true,
    details: {
      departments: {
        phoneNumber: true,
        isDefault: true,
      },
    },
  },
  groupHash: true,
  franchiseHash: true,
  custom: true,
  pageViews: true,
  vin: true,
  isSharedStock: true,
};

export const details = {
  id: true,
  model: true,
  manufacturer: true,
  equipment: {
    label: true,
    highlighted: true,
    category: true,
  },
  variant: true,
  condition: true,
  mainImage: true,
  pageViews: true,
  images: true,
  videos: {
    providerId: true,
    reference: true,
  },
  type: true,
  isFranchiseApproved: true,
  location: {
    hash: true,
    details: {
      name: true,
      address: {
        name: true,
        city: true,
        country: true,
        postcode: true,
        county: true,
        line1: true,
        line2: true,
        line3: true,
        timezone: true,
        hash: true,
      },
      coordinates: {
        lat: true,
        lon: true,
      },
      departments: {
        isDefault: true,
        phoneNumber: true,
        openingHours: {
          weekDay: true,
          hours: {
            start: true,
            close: true,
          },
        },
      },
    },
  },
  saleLocations: {
    id: true,
  },
  price: {
    current: true,
    currencyCode: true,
    vatIncluded: true,
    previous: true,
  },
  groupHash: true,
  franchiseHash: true,
  registration: {
    number: true,
    date: true,
  },
  vin: true,
  cap: {
    id: true,
  },
  odometer: {
    unit: true,
    value: true,
  },
  colour: {
    exterior: true,
    exteriorGeneric: true,
    exteriorCode: true,
    interior: true,
  },
  bodyStyle: true,
  fuel: {
    type: true,
  },
  transmission: {
    type: true,
  },
  engine: {
    size: true,
  },
  efficiency: {
    unit: true,
  },
  battery: {
    capacity: true,
  },
  tax: {
    band: true,
    in12Months: true,
  },
  status: true,
  identifiers: {
    stockId: true,
    fscCode: true,
    salesmasterId: true,
    transUnionMakeModelCode: true,
  },
  description: true,
  companyHash: true,
  numOwners: true,
  technical: {
    acceleration: true,
  },
  range: {
    value: true,
    unit: true,
  },
  emission: {
    co2: true,
  },
  power: {
    maxKw: true,
  },
  electricAttributes: {
    capacityKwh: true,
    chargeTypes: {
      chargeType: true,
      percentage: true,
      timeMinutes: true,
    },
  },
};
